module.exports = __webpack_public_path__ + "img/ai_remove_text.5e301cf4.jpg";